<template>
  <div id="app">
    <ScaleBox :width="1920" :height="963" bgc="transparent" :delay="100" >
      <router-view />
    </ScaleBox>
  </div>
</template>

<script>
import '@/style/elementCss.scss'
import ScaleBox from 'vue2-scale-box'

export default {
  name: 'App',
  components: {ScaleBox}
}
</script>

<style lang="scss">
.el-input__inner {
  height: 32px;
}
.el-button {
  height: 32px;
  padding: 0 16px;
  line-height: 32px;
}
</style>
